// The worker rebuilds earlier turns from the stored rows, so a send only
// carries the latest turn: from the last user message onward (a trailing
// assistant message with tool state included), always marked as trimmed. The
// client may hold only the loaded page, even a single turn, so its messages
// are never the history. A regenerate is cut the same way, unlike the
// backend's `_trim_vercel_history`: the endpoint deletes the conversation's
// last turn before the worker reads the rest, so only a reply in the latest
// turn can be regenerated (see inLatestTurn).
export function latestTurnOnly<M extends { role: string }>(
  messages: M[]
): { messages: M[]; history_trimmed?: true } {
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === "user") {
      return { messages: messages.slice(i), history_trimmed: true };
    }
  }
  return { messages };
}

// Whether a reply belongs to the latest turn: no user message comes after it.
// A turn can hold several assistant messages, so this is not "is the last".
export function inLatestTurn(
  messages: { id: string; role: string }[],
  messageId: string
): boolean {
  const i = messages.findIndex((m) => m.id === messageId);
  return i >= 0 && messages.slice(i + 1).every((m) => m.role !== "user");
}
